"use client";

import React, { forwardRef } from "react";
import DatePicker from "react-datepicker";
import { Input } from "./Input"; // Usar o Input do Shadcn UI
import { cn } from "../../lib/utils";

import { registerLocale, setDefaultLocale } from "react-datepicker";
import ptBR from "date-fns/locale/pt-BR";

import "react-datepicker/dist/react-datepicker.css"; // Importar os estilos padrão do react-datepicker

// Registrar o locale pt-BR
registerLocale("pt-BR", ptBR);
setDefaultLocale("pt-BR"); // Definir como locale padrão para todos os DatePickers

const CustomInput = forwardRef(({ value, onClick, placeholder, className, ...props }, ref) => (
  <Input
    type="text"
    onClick={onClick}
    value={value}
    placeholder={placeholder}
    className={cn("w-full", className)}
    readOnly // Para evitar que o usuário digite diretamente
    ref={ref}
    {...props}
  />
));

CustomInput.displayName = "CustomInput";

const DatePickerComponent = ({ date, setDate, placeholder = "Selecione uma data", disabled = false, className, ...props }) => {
  return (
    <DatePicker
      selected={date}
      onChange={(newDate) => setDate(newDate)}
      customInput={<CustomInput placeholder={placeholder} className={className} />}
      dateFormat="dd/MM/yyyy"
      locale="pt-BR"
      disabled={disabled}
      popperPlacement="bottom-start"
      placeholderText={placeholder}
      {...props}
    />
  );
};

export { DatePickerComponent as DatePicker };